export const adaptStore = (data: IStore): LocationStore => {
	return {
		id: data.id,
		name: data.name,
		region: data.region ?? null,
		area: data.area ?? null,
		lastsync: data.lastsync,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptStores = (data: IStore[]): LocationStore[] => {
	return data.map(adaptStore);
};
